import { combineReducers } from "redux";
import cart from "./cart";
import current_user from "./current_user";
import customer from "./customer";
import products from "./products";

const root = combineReducers({ cart, customer, current_user, products });

export default root;
